import React from 'react';

import { padding } from '@lumapps/classnames';
import { ColorPalette, FlexBox, Icon, Size, Text, Theme } from '@lumapps/lumx/react';

import { useLikes } from '../../hook/useLikes';
import type { LikeButtonProps } from '../LikeButton';

interface PublicLikesProps extends LikeButtonProps {
    theme: Theme;
}

/**
 * Display the likes in public mode.
 * */
export const PublicLikes: React.FC<PublicLikesProps> = ({ reactionCounts, currentUserReactions, theme }) => {
    const { defaultIcon, likeCount } = useLikes({ reactionCounts, currentUserReactions });

    return (
        <FlexBox orientation="horizontal" hAlign="center" gap="tiny" className={padding('all', 'regular')}>
            <Icon theme={theme} icon={defaultIcon} size={Size.xs} />
            <Text as="span" typography="body1" color={theme === Theme.dark ? ColorPalette.light : ColorPalette.dark}>
                {likeCount}
            </Text>
        </FlexBox>
    );
};
